import React, { useCallback } from "react";
import { Form, Button, Image } from "semantic-ui-react";
import { useFormik } from "formik";
//import { Auth } from "../../../../../api";
import { useDropzone } from "react-dropzone";
import { initialValues, validationSchema } from "./PartnerForm.form";
import { toast, ToastContainer } from "react-toastify";

//const authController = new Auth();

export function PartnerFormOne(props) {
  const { updateFormData, formData, nextStep, user } = props;
  //console.log("user", user);
  const formik = useFormik({
    initialValues: initialValues(user.user, formData),
    validationSchema: validationSchema(),
    validateOnChange: false, // Intenta cambiar esto a true para depuración
    onSubmit: async (values) => {
      try {
        // console.log("Valores antes de actualizar:", values);  // Verifica si esto se ejecuta
        updateFormData(values);
        //console.log("Estado formData actualizado:", formData);
        nextStep(); // Avanza al siguiente paso
      } catch (error) {
        toast.error(`Error: ${error.message}`, {
          position: "top-center",
          autoClose: false,
          closeOnClick: true,
        });
      }
    },
  });

  const onDrop = useCallback(
    (acceptedFiles) => {
      const file = acceptedFiles[0];
      if (file) {
        const validMimeTypes = ["image/jpeg", "image/png"];
        if (validMimeTypes.includes(file.type)) {
          formik.setFieldValue("miniature", URL.createObjectURL(file));
          formik.setFieldValue("file", file);
        } else {
          console.log("Tipo de archivo no soportado:", file.type);
        }
      }
    },
    [formik],
  );

  const { getRootProps, getInputProps } = useDropzone({
    accept: {
      "image/jpeg": [".jpeg", ".jpg"],
      "image/png": [".png"],
    },
    onDrop,
    multiple: false,
  });

  const getMiniature = () => {
    if (formik.values.file) {
      return formik.values.miniature;
    } else if (formik.values.miniature) {
      // si viene del servidor es que estamos actualizando
      return `${formik.values.miniature}`;
    }
    return null;
  };
  return (
    <>
      <ToastContainer />
      <Form onSubmit={formik.handleSubmit}>
        <div className="post-form__miniature" {...getRootProps()}>
          <input {...getInputProps()} />
          {getMiniature() ? (
            <Image size="small" src={getMiniature()} />
          ) : (
            <div>
              <span> Arrastra tu Logo </span>
            </div>
          )}
        </div>
        <Form.Input
          type="text"
          icon="user"
          iconPosition="left"
          name="name"
          placeholder="Nombre comercial"
          onChange={formik.handleChange}
          value={formik.values.name}
          error={
            formik.errors.name
              ? { content: formik.errors.name, pointing: "above" }
              : null
          }
        />
        <Form.Input
          type="text"
          icon="barcode"
          iconPosition="left"
          name="code"
          placeholder="CIF/NIF"
          onChange={formik.handleChange}
          value={formik.values.code || ""}
          error={
            formik.errors.code
              ? { content: formik.errors.code, pointing: "above" }
              : null
          }
        />
        <Form.Input
          type="text"
          icon="phone"
          iconPosition="left"
          name="mobile"
          placeholder="Móvil"
          onChange={formik.handleChange}
          value={formik.values.mobile}
          error={
            formik.errors.mobile
              ? { content: formik.errors.mobile, pointing: "above" }
              : null
          }
        />
        <Form.Input
          type="text"
          name="email"
          placeholder="Correo electrónico"
          onChange={formik.handleChange}
          value={formik.values.email}
          error={
            formik.errors.email
              ? { content: formik.errors.email, pointing: "above" }
              : null
          }
        />
        <Form.Input
          type="url"
          icon="world"
          iconPosition="left"
          name="socialNetworks.website" // Asegúrate de que el nombre esté correctamente mapeado
          placeholder="Sitio web"
          onChange={formik.handleChange}
          value={formik.values.socialNetworks?.website || ""} // Asegúrate de que el valor sea correcto
          error={
            formik.errors.socialNetworks?.website
              ? {
                  content: formik.errors.socialNetworks.website,
                  pointing: "above",
                }
              : null
          }
        />
        <div className="formgroup">
          <Form.Group>
            <Button
              type="submit"
              color="green"
              style={{ width: "33.3333%", marginLeft: "33.3333%" }}
            >
              Siguiente
            </Button>
          </Form.Group>
        </div>
      </Form>
    </>
  );
}
